import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { DataResponse, ShareLinkService, ShareLink } from 'us-web-services';
import { Button } from '../..';
import { useDependencies } from '../../../dependencies';
import { TrackerTypes } from '../../../services';
import { DisplayUtil } from '../../../utils';

const ICON_WHITE_URL = 'https://assets.urbansitter.com/static/img/logos/urbansitter-icon-white.svg';

const GiveButton = (): JSX.Element => {
  const { t } = useTranslation();
  const {
    services: { tracker },
    stores: { user },
  } = useDependencies();
  const { id } = user.user!;
  const [shareUrl, setShareUrl] = useState<string>('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!id) return;

    const params: ShareLink = {
      userId: id,
      platform: DisplayUtil.getPlatform(),
      campaign: 'parentInvite',
    };

    ShareLinkService.post(params).then((response: DataResponse<ShareLink>) => {
      setShareUrl(response.data.data?.branchLink ?? '');
    });
  }, []);

  const copyText = (text: string): Promise<void> => navigator.clipboard.writeText(text);

  const handleGiveClick = (): void => {
    tracker.track('copied-link', { elementId: 'parent-referral-give-get' }, 'referral-parent', { services: [TrackerTypes.GA] });
    copyText(shareUrl);
    setOpen(true);
  };

  const handleGiveBlur = (): void => setOpen(false);

  return (
    <div className='hidden xl:inline-block xl:relative'>
      <Button
        className='align-middle text-white rounded-full px-6 h-10 xl:ml-2 text-sm bg-gradient-to-r from-emerald to-sapphire-700 font-semibold hover:opacity-70'
        onClick={handleGiveClick}
        onBlur={handleGiveBlur}
      >
        <span className='inline-block align-middle'>
          <span>{t('components.header.giveButton.give25')}</span>
        </span>
        <img src={ICON_WHITE_URL} alt='UrbanSitter icon' className='h-5 ml-1 hidden lg:inline-block' />
      </Button>
      <div
        className={`absolute top-10 w-72 -right-20 m-auto bg-sapphire border-sapphire-700 text-white text-left text-sm p-4 border drop-shadow-md rounded mt-2 z-10 active:block ${
          open ? 'block' : 'hidden'
        }`}
      >
        <span className='block font-bold mb-2'>{t('components.header.giveButton.linkCopied')}</span>
        <p>{t('components.header.giveButton.message')}</p>
      </div>
    </div>
  );
};

export default GiveButton;
